import React from "react";
import { PlateElement, type PlateElementProps } from "platejs/react";

export function ParagraphBlock(props: PlateElementProps) {
  return (
    <PlateElement {...props} as="p" style={{ margin: "6px 0", lineHeight: 1.5, color: "#ddd" }}>
      {props.children}
    </PlateElement>
  );
}
